import { fork } from 'redux-saga/effects';
import stakingSaga from 'store/staking/sagas';
/* PLOP_INJECT_IMPORT_SAGA */
import userSaga from 'store/user/sagas';

export default function* rootSaga() {
  yield fork(userSaga);
  yield fork(stakingSaga);
}
